<template>
  <div class="clock">
    <halfClock :num="val" :ampm="ap" :text-color="textColor"></halfClock>
    <halfClock :num="tempVal" :ampm="tempAp" :text-color="textColor" btmpart="true"></halfClock>
    <halfClock v-show="flipshow" :num="tempVal" :ampm="tempAp" :text-color="textColor" :class="['page_front',flipping?'page_front_end':'']"></halfClock>
    <halfClock v-show="flipshow" :num="val" :ampm="ap" :text-color="textColor" btmpart="true" :class="['page_back',flipping?'page_back_end':'']"></halfClock>
  </div>
</template>

<script>
import { watch, unref, reactive, toRefs, onMounted, computed, watchEffect } from 'vue'
import halfClock from './halfClock'
import getap from '../utils/getampm'
export default {
  components: { halfClock },
  props: {
    num: {
      default: 0
    },
    ampm: {
      default: false
    },
    textColor: {
      type: String,
      default: '#ffffff'
    }
  },
  setup (props) {
    const data = reactive({
      tempVal: 0,
      val: 0,
      tempAp: '',
      ap: '',
      flipshow: false,
      flipping: false,
      cache: []
    })
    let timeout
    watchEffect(()=>{
      // console.log('watchEffect',props.num,props.ampm)
      let temp = getap(props.ampm, props.num)
      data.val = temp.t
      data.ap = temp.ap
      data.flipshow = true
      setTimeout(() => {
        data.flipping = true
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          data.tempVal = temp.t
          data.tempAp = temp.ap
          data.flipshow = false
          data.flipping = false
        }, 600);
      }, 0);
    })
    return {
      ...toRefs(data)
    }
  }
}
</script>

<style lang="less">
.clock{
  position: relative;
  width: 240px;
  height: 240px;
  font-size: 160px;
}
.page_front,.page_back{
  position: absolute;
  width: 100%;
  height: 50%;
  backface-visibility: hidden;
  transition: all 0.6s ease-in;
}
.page_front{
  top: 0;
  transform-origin: bottom;
  transform: rotateX(360deg);
}
.page_back{
  top: 50%;
  transform-origin: top;
  transform: rotateX(180deg);
}
.page_front_end{
  transform: rotateX(180deg);
}
.page_back_end{
  transform: rotateX(0deg);
}
</style>
